export enum FieldType {
  RADIO = 'radio',
  SELECT = 'select',
  TEXT = 'text',
  NUMBER = 'number',
  CHECKBOX = 'checkbox',
}

export type Field = {
  name: string;
  label: string;
  searchOptions: {
    type: FieldType;
    order: number;
  };
  options?: {
    id: string;
    name: string;
  }[];
};
